import { customSeriesDefaultOptions } from 'lightweight-charts'

/**
 * BubbleFillSeries — círculos de radio variable en el precio exacto del bin
 * ganador de `scanMaxDelta` (I1.2/I2 del spec
 * docs/specs/Spec_Orderflow_Indicador_I1_I2.md). Molde: ZoneFillSeries
 * (patron_ruptura_quantum) / BoxFillSeries (ict_quantum) -- mismo contrato de
 * plugin de serie custom de lightweight-charts, adaptado a un punto=un
 * círculo en vez de un polígono de relleno.
 *
 * `setMarkers` nativo DESCARTADO explícitamente (Enmienda 1, punto 4 del
 * spec): un marker de LWC ancla al BORDE de la vela (aboveBar/belowBar), no
 * al precio exacto del bin -- las burbujas necesitan el precio real.
 */
const _RADIUS_PX = {
  tiny: 3,
  small: 5,
  normal: 7,
  large: 10,
  huge: 14,
}

class BubbleFillPaneRenderer {
  constructor() {
    this._data = null
    this._options = null
  }

  update(data, options) {
    this._data = data
    this._options = options
  }

  draw(target, priceConverter) {
    if (!this._data || !this._options) return
    const { bars, visibleRange } = this._data
    if (!visibleRange || !bars || bars.length === 0) return

    const from = Math.max(0, Math.floor(visibleRange.from))
    const to = Math.min(bars.length - 1, Math.ceil(visibleRange.to))
    if (from > to) return

    target.useMediaCoordinateSpace(scope => {
      const ctx = scope.context

      for (let i = from; i <= to; i++) {
        const bar = bars[i]
        const d = bar?.originalData
        if (!d || d.price == null || !Number.isFinite(d.price)) continue
        const x = bar.x
        if (!Number.isFinite(x)) continue

        const y = priceConverter(d.price)
        if (y == null || Number.isNaN(y)) continue

        const radius = _RADIUS_PX[d.sizeTier] ?? _RADIUS_PX.tiny

        ctx.beginPath()
        ctx.arc(x, y, radius, 0, Math.PI * 2)
        // `bubbleColor`, no `color`: lightweight-charts trata `color` como
        // campo reservado en el dato de una serie y lo descarta de
        // `originalData` (confirmado empíricamente -- ver mensaje de entrega
        // del fix, root cause de las burbujas grises). Cualquier otro nombre
        // de campo (sizeTier, price) sobrevive intacto.
        ctx.fillStyle = d.bubbleColor || this._options.fillColor
        ctx.fill()
      }
    })
  }
}

export class BubbleFillSeries {
  constructor() {
    this._renderer = new BubbleFillPaneRenderer()
  }

  renderer() {
    return this._renderer
  }

  update(data, seriesOptions) {
    this._renderer.update(data, seriesOptions)
  }

  priceValueBuilder(plotRow) {
    return [plotRow.price]
  }

  isWhitespace(data) {
    return data == null || data.price == null
  }

  defaultOptions() {
    return {
      ...customSeriesDefaultOptions,
      color: 'rgba(0,0,0,0)',
      fillColor: 'rgba(148,163,184,0.5)',
    }
  }
}
